import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  Avatar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import React from 'react';
import Button from '../components/Button';
import { MEDICATION_STATUS } from '../constants';
import MedicationIcon from '@mui/icons-material/Medication';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { getWeekdaysWithDates } from '../utils';

const MedicationReminderSidebar = ({ todayMedications, handleUpdateEvent, onFilterDate }) => {
  const [selectedDay, setSelectedDay] = React.useState(3);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Paper
      sx={{
        width: isMobile ? '100%' : 'auto',
        height: isMobile ? 'auto' : '65vh',
        p: isMobile ? 2 : 3,
        borderRadius: 2,
        bgcolor: 'background.paper',
        mr: isMobile ? 0 : 2,
        mb: isMobile ? 2 : 0,
        boxShadow: 'none',
        overflow: 'scroll',
      }}
      className="hide-scroll"
    >
      <Stack spacing={isMobile ? 2 : 3}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            bgcolor: 'background.paper',
            borderRadius: 1,
            p: isMobile ? 1 : 2,
          }}
        >
          <Typography variant={isMobile ? 'h6' : 'h5'}>Today, {moment().format('MMM DD')}</Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: '10px',
              overflowX: isMobile ? 'auto' : 'visible',
              pb: isMobile ? 1 : 0,
            }}
          >
            {getWeekdaysWithDates().map((day, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  bgcolor: index === selectedDay ? '#01796b' : '#fff',
                  borderRadius: '20px',
                  p: isMobile ? 0.5 : 1,
                  mx: isMobile ? 0.5 : 0,
                  minWidth: isMobile ? '40px' : 'auto',
                  color: index === selectedDay ? '#fff' : 'black',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setSelectedDay(index);
                  onFilterDate(day.format('YYYY-MM-DD'));
                }}
              >
                <Typography variant="body2">{day.format('ddd')}</Typography>
                <Typography variant="body2">{day.format('DD')}</Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <List sx={{ width: '100%' }}>
          {isEmpty(todayMedications) && <Typography variant="body1">No Reminders found!</Typography>}
          {!isEmpty(todayMedications) &&
            todayMedications.map((item, index) => (
              <React.Fragment key={index}>
                <ListItem
                  alignItems="flex-start"
                  sx={{
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? 1 : 0,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
                    <ListItemAvatar>
                      <Avatar
                        sx={{
                          bgcolor: item?.medicationData?.color || 'green',
                        }}
                      >
                        <MedicationIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body1"
                          sx={{
                            textDecoration: item.status !== MEDICATION_STATUS.pending ? 'line-through' : 'none',
                          }}
                        >
                          {item.title}
                        </Typography>
                      }
                      secondary={
                        <>
                          <Typography variant="body2">{moment.unix(item?.start).format('h:mm a')}</Typography>
                          <Typography variant="body2">{item?.medicationData?.howToTake || ''}</Typography>
                        </>
                      }
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1,
                      alignItems: isMobile ? 'stretch' : 'center',
                      width: isMobile ? '100%' : 'auto',
                      mt: isMobile ? 1 : 0,
                    }}
                  >
                    {item.status === MEDICATION_STATUS.pending && (
                      <div style={{ display: isMobile ? 'flex' : 'grid', gap: isMobile ? '8px' : 0 }}>
                        <Button
                          text="Take"
                          style={{
                            mb: isMobile ? 0 : 1,
                            fontSize: 12,
                            width: isMobile ? '100%' : 80,
                          }}
                          onClick={() => handleUpdateEvent(item?._id, MEDICATION_STATUS.completed)}
                        />

                        <Button
                          text="Skip"
                          bg="light"
                          style={{
                            fontSize: 12,
                            width: isMobile ? '100%' : 80,
                          }}
                          onClick={() => handleUpdateEvent(item?._id, MEDICATION_STATUS.cancelled)}
                        />
                      </div>
                    )}
                    {item.status === MEDICATION_STATUS.completed && (
                      <Button
                        text="Taken"
                        bg="light"
                        disabled={true}
                        style={{
                          fontSize: 12,
                          width: isMobile ? '100%' : 80,
                        }}
                      />
                    )}
                    {item.status === MEDICATION_STATUS.cancelled && (
                      <Button
                        text="Skipped"
                        bg="light"
                        disabled={true}
                        style={{
                          fontSize: 12,
                          width: isMobile ? '100%' : 80,
                        }}
                      />
                    )}
                  </Box>
                </ListItem>
                {index < 2 && <Divider />}
              </React.Fragment>
            ))}
        </List>
      </Stack>
    </Paper>
  );
};

export default MedicationReminderSidebar;
